import React from 'react';
import { motion } from 'framer-motion';
export function TestimonialsSection() {
  const testimonials = [{
    quote: 'I caught a $2,400 insurance discrepancy at Day-7 because I knew exactly what to ask. The checklist paid for itself 100x over.',
    author: 'Sarah M.',
    context: 'First-time buyer, Texas'
  }, {
    quote: 'Instead of panicking when the lender went silent, I used the scripts. Got a reply in 20 minutes with the updated numbers.',
    author: 'David K.',
    context: 'Closing in 14 days'
  }, {
    quote: 'My title company was surprised I had the numbers ready before they did. This system makes you look like a pro.',
    author: 'Elena R.',
    context: 'Refinancing, Florida'
  }];
  return <section className="py-16 lg:py-24 border-t border-[#1B6B3A]/10" data-id="element-154">
      <div className="max-w-3xl mx-auto px-6" data-id="element-155">
        <h2 className="text-3xl lg:text-4xl font-serif font-bold text-[#1A1A1A] mb-12 lg:mb-16 text-center" data-id="element-156">
          What buyers are saying
        </h2>

        <div className="space-y-12 lg:space-y-16" data-id="element-157">
          {testimonials.map((item, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.6,
          delay: i * 0.1
        }} className="pl-6 lg:pl-8 border-l-4 border-[#1B6B3A]" data-id="element-158">
              <p className="text-xl lg:text-2xl font-serif italic text-[#3D3D3D] mb-4 leading-relaxed" data-id="element-159">
                "{item.quote}"
              </p>
              <div className="flex items-center gap-2 text-sm lg:text-base font-sans" data-id="element-160">
                <span className="font-bold text-[#1A1A1A]" data-id="element-161">{item.author}</span>
                <span className="text-[#6B6B6B]" data-id="element-162">— {item.context}</span>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}